import React from "react";
import PropTypes from "prop-types";

import QuickCaptureBtn from "../QuickCaptureBtn";
import { wrapCloze } from "./text";

// QuickCaptureEntry#text's limit. Longer sentences can't be captured, so they get no
// button rather than one that fails.
const QUICK_CAPTURE_MAX_LENGTH = 200;

// A subtle "+" that saves a sentence or phrase to a collection through Quick Capture.
// Quick Capture already does everything this needs - the sentence and translation, the
// collection picker, the Pro gating (non-Pro users get its promo and demo) - so this is
// just a way in, pre-filled.
//
// Auto-submitted when we know what to capture: a phrase (Quick Capture writes a sentence
// around it) or a sentence with its cloze chosen. A sentence without one opens
// pre-filled but unsubmitted, so the learner can highlight the word to practise.
export default function SaveToCollection({ cloze, quickCapture, sentence, phrase }) {
  const text = phrase || wrapCloze(sentence, cloze) || sentence;
  if (!quickCapture || !text || text.length > QUICK_CAPTURE_MAX_LENGTH) return null;

  return (
    <QuickCaptureBtn
      {...quickCapture}
      autoSubmitInitialText={!!phrase || text !== sentence}
      className="ftf-capture"
      initialText={text}
      title="Add to a collection"
    >
      <span aria-hidden="true">+</span>
      <span className="sr-only">Add to a collection</span>
    </QuickCaptureBtn>
  );
}

SaveToCollection.propTypes = {
  cloze: PropTypes.string,
  phrase: PropTypes.string,
  quickCapture: PropTypes.object,
  sentence: PropTypes.string,
};
